import React, { useEffect, useState } from "react";
import { Image, message, Spin } from "antd";
import { useSelector } from "react-redux";
import { selectBaseUrl } from "../../redux/slices/envSlice";
import { secureImageGet } from "../../endpoints/API";

// const SecureImage = ({ path, width = 100 }) => {
//   const baseUrl = useSelector(selectBaseUrl);
//   const [imgSrc, setImgSrc] = useState(null);
//   const [loading, setLoading] = useState(true);
  
//   const ADMINBASE_URL = process.env.REACT_APP_BASE_URL

//   useEffect(() => {
//     let isMounted = true;

//     const fetchImage = async () => {
//       try {
//         const res = await secureImageGet(`${ADMINBASE_URL}secured_media_access/${encodeURIComponent(path)}`);

//         if (res.data?.url && isMounted) {
//           setImgSrc(res.data.url); // Use presigned URL directly
//         } else {
//           throw new Error("No URL returned");
//         }
//       } catch (error) {
//         message.error("Error fetching image");
//       } finally {
//         if (isMounted) setLoading(false);
//       }
//     };

//     fetchImage();

//     return () => {
//       isMounted = false;
//     };
//   }, [path, baseUrl]);

//   if (loading) return <Spin />;
//   if (!imgSrc) return <span style={{ color: "red" }}>Image not available</span>;

//   return (
//     <Image
//       src={imgSrc}
//       width={width}
//       alt="Certificate"
//       style={{ borderRadius: 4, objectFit: "cover" }}
//     />
//   );
// };

// export default SecureImage;

const SecureImage = ({ path, width = 100 }) => {
  const baseUrl = useSelector(selectBaseUrl);
  const [imgSrc, setImgSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const ADMINBASE_URL = process.env.REACT_APP_BASE_URL

  useEffect(() => {
    let objectUrl;
    const fetchImage = async () => {

      try {
        const res = await secureImageGet(`${ADMINBASE_URL}secured_media_access${path}`);

        if (!res.statusText =="OK") throw new Error(`Failed to load image: ${res.status}`);

        const blob = res.data;

        // if (!blob.type.startsWith("image/")) {
        //   const text = await blob.text();
        //   console.error("Unexpected content:", text);
        //   throw new Error(`Invalid content-type: ${blob.type}`);
        // }

        objectUrl = URL.createObjectURL(blob);
        setImgSrc(objectUrl);
      } catch (error) {
        message.error("Error fetching image");
      } finally {
        setLoading(false);
      }
    };

    fetchImage();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [path]);

  if (loading) return <Spin />;
  if (error || !imgSrc) {
    return <span style={{ color: "red" }}>Image not available</span>;
  }

  return (
    <Image
      src={imgSrc}
      width={width}
      alt="Certificate"
      style={{ borderRadius: 4, objectFit: "cover" }}
    />
  );
};

export default SecureImage;
